import PieChartGenerator from "../../../../chart/PieChartGenerator";
import {OTHER_USERS_ENTITY_ID} from "../../../../constants";
import messageResource from "../../../../messageResource";

export default class Generator extends PieChartGenerator {

    _prepareChartSettings(chartData, config) {
        return {
            ...super._prepareChartSettings(chartData,config),
            radius: 80,
            innerRadius: 30,
            mouseWheelScrollEnabled: true
        }
    }

    _getDataProvider(chartData, config) {
        const dataProvider = [];

        let otherUsersItem = null;

        for (let i = 0; i < chartData.length; i++) {
            let currentItem = chartData[i];
            if (currentItem["userId"] === OTHER_USERS_ENTITY_ID) {
                otherUsersItem = currentItem;
                continue;
            }
            dataProvider.push({
                "category": currentItem["formattedName"],
                "value": currentItem["spentTime"]
            })
        }

        if (otherUsersItem) {
            dataProvider.push({
                "category": messageResource.getMessage("report.other_users"),
                "value": otherUsersItem["spentTime"],
                "sectorColor": "#dbdbdb"
            })
        }
        return dataProvider;
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/chart/Generator.js